/** Normalize doctor display name for comparison (strip Dr., lowercase, collapse spaces). */
export function normalizeDoctorName(name) {
  return String(name || '')
    .toLowerCase()
    .replace(/^(dr\.?\s*)+/gi, '')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Whether a queue row belongs to the logged-in doctor (manager sees all). */
export function doctorQueueMatch(row, user) {
  if (!row || !user) return false;
  if (user.role === 'manager') return true;
  const rowDoc = normalizeDoctorName(row.doctor);
  const userName = normalizeDoctorName(user.name);
  if (!rowDoc || !userName) return false;
  if (rowDoc === userName) return true;
  const rowLast = rowDoc.split(/\s+/).pop();
  const userLast = userName.split(/\s+/).pop();
  if (!rowLast || !userLast) return false;
  return rowDoc.includes(userLast) || userName.includes(rowLast) || rowLast === userLast;
}

/** Display doctor name once with Dr. prefix (avoids "Dr. Dr. Name"). */
export function formatDoctorLabel(name) {
  if (!name) return '—';
  const t = String(name).trim();
  if (/^dr\.?\s/i.test(t)) return t;
  return `Dr. ${t}`;
}
